import { Redirect } from 'expo-router';
import React from 'react';

/** Native-only authenticator failure host. Web does not use this route. */
export default function UaePassFailWebRoute() {
  return <Redirect href="/welcome" />;
}
